import React from "react";
import { FaFacebookF, FaXTwitter, FaLinkedinIn, FaYoutube, FaGithub } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import vertical_shot_buildings1 from "../../assets/verticalshotcity_sidebarBackground.svg";
import sideBarLogo from "../../assets/sideBarLogo.svg";
import drone2 from "../../assets/drone2.svg";
const SupportSidebar = () => {
  const navigate = useNavigate();
  return (
    <div className="h-screen w-[400px] md:w-[480px] flex flex-col justify-between font-sans relative overflow-hidden">
      {/* Header */}
      <div>
        <div className="px-5 mb-5 mt-2">
          <h2 className="font-bold text-sm mb-1 tracking-tight">Email support</h2>
          <p className="text-xs text-gray-500 mb-1">We'll get back to you within 24 hours.</p>
          <a href="mailto:support@asseteye.com" className="text-xs underline font-semibold">
            support@asseteye.com
          </a>
        </div>

        <hr className="border-gray-100 my-3" />

        {/* Call Us */}
        <div className="px-5">
          <h2 className="font-bold text-sm mb-1 tracking-tight">Call Us</h2>
          <p className="text-xs text-gray-500 mb-1">Mon - Fri, 9:00 AM - 5:00 PM (UTC +10:00).</p>
          <div className="flex flex-col gap-1 mt-2">
            <a href="tel:3085550121" className="text-xs font-bold underline">
              (308) 555-0121
            </a>
            <a href="tel:2255550118" className="text-xs font-bold underline">
              (225) 555-0118
            </a>
          </div>
        </div>
        <hr className="border-gray-100 my-5" />
      </div>
      <img
        src={drone2}
        alt="Drone"
        className="absolute scale-x-[-1] left-[-12%] top-[33%] max-w-[800px] max-h-[800px] opacity-10 pointer-events-none"
      />
      {/* Footer Polygon Section */}
      <div className="absolute bottom-0 left-0 w-full h-[60%]">
        {/* light green shadow strip */}
        <div className="absolute inset-0 clip-content-light"></div>

        {/* dark green polygon with image */}
        <div className="absolute inset-0 bg-green-200 clip-content">
          <img
            src={vertical_shot_buildings1}
            alt="Cover_Image"
            className="w-full h-full object-cover opacity-100"
          />

          <div className="absolute top-[45%] left-5 w-[250px] md:w-[150px] flex flex-col">
            <img src={sideBarLogo} alt="Logo" className="w-full h-auto" />
            {/* <span className="text-[33px] font-bold text-[#114926]">AssetEye</span>
            <span className="text-xs text-center">powered by DroneTjek</span> */}
          </div>

          <div className="absolute bottom-6 left-5 w-[80%]">
            <p className="text-sm md:text-md leading-relaxed">
              Next-Gen Drone Solutions for Detecting Structural Damage and Estimating Repair Costs.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportSidebar;
